import styled from 'styled-components';

import { DiagnosisState } from '@/types/hospital';
import { getDiagnosisStateText } from '@/utils/format';

const DiagnosisStatus = (props: { type: DiagnosisState }) => {
  const text = getDiagnosisStateText(props.type);
  switch (props.type) {
    case DiagnosisState.On:
      return (
        <StatusWrapper>
          <StatusOn />
          <StatusText type={DiagnosisState.On}>{text}</StatusText>
        </StatusWrapper>
      );
    case DiagnosisState.Off:
      return (
        <StatusWrapper>
          <StatusText type={DiagnosisState.Off}>{text}</StatusText>
        </StatusWrapper>
      );
    case DiagnosisState.Lunch:
      return (
        <StatusWrapper>
          <StatusText type={DiagnosisState.Lunch}>{text}</StatusText>
        </StatusWrapper>
      );
    case DiagnosisState.DayOff:
      return (
        <StatusWrapper>
          <StatusText type={DiagnosisState.DayOff}>{text}</StatusText>
        </StatusWrapper>
      );
    case DiagnosisState.Unknown:
      return null;
  }
};

export default DiagnosisStatus;

const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 18px;
`;

const StatusOn = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background-color: ${({ theme }) => theme.color.green500};
  margin-right: 4px;
`;

const StatusText = styled.span<{ type: DiagnosisState }>`
  ${({ theme, type }) => `
        ${theme.typography.UI13M}
        color: ${type === DiagnosisState.On ? theme.color.green700 : theme.color.gray300};
    `}
`;
